<template>
  <div class="px-9 home-page">
    <v-row v-if="!isMobileView">
      <v-col cols="12">
        <span class="text-12"> Good Morning</span>
        <div class="text-700">Franklin Benedict</div>
      </v-col>
    </v-row>

    <v-row v-if="!isMobileView">
      <v-col cols="6" md="2" v-for="(status, index) in statuses" :key="index">
        <v-card height="80" :color="status.color" class="top-card pa-3">
          <v-row>
            <v-col cols="9">
              <div style="font-size: 13px; font-weight: 600">{{ status.label }}</div>
              <div class="text-20">{{ status.count }}</div>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center">
              <v-icon :color="status.iconColor" size="30">{{ status.icon }}</v-icon>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="d-flex">
      <v-col cols="4"></v-col>
      <v-col cols="4" md="4" class="pb-0" v-if="!isMobileView">
        <v-text-field prepend-inner-icon="mdi-magnify" variant="outlined" label=""> </v-text-field>
      </v-col>
      <v-col cols="12" md="4" xs="12" class="pb-0">
        <div class="d-flex justify-end" style="column-gap: 35px; padding-top: 5px">
          <a
            href="#"
            :class="{ active: activeLink === 'all-items' }"
            @click.prevent="setActive('all-items')"
          >
            All Items
          </a>
          <a
            href="#"
            :class="{ active: activeLink === 'snoozed' }"
            @click.prevent="setActive('snoozed')"
          >
            Snoozed
          </a>
          <a
            href="#"
            :class="{ active: activeLink === 'email-me' }"
            @click.prevent="setActive('email-me')"
          >
            Email Me
          </a>
          <a
            href="#"
            :class="{ active: activeLink === 'export' }"
            @click.prevent="setActive('export')"
          >
            Export
          </a>
        </div>
      </v-col>
      <v-col cols="8" md="4" xs="8" class="pb-0" v-if="isMobileView">
        <v-text-field prepend-inner-icon="mdi-magnify" variant="outlined" label=""> </v-text-field>
      </v-col>
      <v-col cols="4" md="4" class="pb-0" v-if="isMobileView">
        <div class="d-flex align-center justify-end" style="column-gap: 30px">
          <v-btn color="#FDD9DB" icon fab size="x-small">
            <v-icon color="#2E3A59" size="medium"> mdi mdi-filter-outline </v-icon>
          </v-btn>
          <v-btn color="#FDD9DB" icon fab size="x-small">
            <v-icon color="#2E3A59" size="medium"> mdi-download </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4" class="pt-0" v-if="!isMobileView">
        <v-card class="mb-4" style="margin-top: -56px">
          <v-card-title>Distribution</v-card-title>
          <v-card-text>
            <canvas id="distribution"></canvas>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>Task Trend</v-card-title>
          <v-card-text>
            <canvas id="taskTrend">Trend of the Inflow of Task by Day (Month)</canvas>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" xs="12" class="pt-0">
        <div
          style="background: #efefef; border-radius: 12px"
          class="pa-5 mb-2"
          v-for="(item, index) in tasks"
          :key="index"
        >
          <v-row @click="actionpage">
            <v-col cols="12" md="8" xs="12" v-if="!isMobileView">
              <div class="d-flex align-center" style="column-gap: 20px">
                <div class="text-14-600" style="color: #b5b2b2">{{ item.code }}</div>
                <div>|</div>
                <div class="text-14-600" style="color: #b5b2b2">{{ item.text }}</div>
                <div class="tag" :style="{ 'background-color': this.getColor(item.status) }">
                  {{ item.status }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="12" xs="12" v-else>
              <span class="text-14-600" style="color: #b5b2b2">
                {{ item.code }}
              </span>
              <span class="mx-2">|</span>
              <span class="text-14-600" style="color: #b5b2b2">
                {{ getInitials(item.text) }}
              </span>
              <span
                class="tag float-right"
                :style="{ 'background-color': this.getColor(item.status) }"
              >
                {{ item.status }}
              </span>
            </v-col>
            <v-col cols="4" md="4" class="pt-1" v-if="!isMobileView">
              <div class="d-flex align-center justify-end" style="column-gap: 30px">
                <v-btn color="#FDD9DB" icon fab size="x-small">
                  <v-icon color="#2E3A59" size="medium"> mdi-bell-off </v-icon>
                </v-btn>
                <v-btn color="#FDD9DB" icon fab size="x-small">
                  <v-icon color="#2E3A59" size="medium">
                    mdi mdi-message-processing-outline
                  </v-icon>
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" md="12" class="pt-0" v-if="!isMobileView">
              <div class="text-16-400">{{ item.title }}</div>
            </v-col>

            <v-col cols="12" md="12" class="pt-0">
              <div :class="{ 'text-16-500': !isMobileView, 'text-14-500': isMobileView }">
                {{ item.description }}
              </div>
            </v-col>

            <v-col cols="6" md="4" class="pt-0">
              <div class="d-flex align-center">
                <v-avatar color="#07AF07" :size="isMobileView ? 22 : 28" class="mr-2">
                  <span :class="{ 'text-14-600': !isMobileView, 'text-12': isMobileView }">
                    {{ getInitials(item.username) }}
                  </span>
                </v-avatar>
                <div :class="{ 'text-14-600': !isMobileView, 'text-12-400': isMobileView }">
                  {{ item.username }}
                </div>
              </div>
            </v-col>
            <v-col cols="8" md="4" class="pt-0">
              <span style="color: #b5b2b2" class="text-14-400" v-if="isMobileView">
                Assigned on
              </span>
              <div
                class="d-flex align-center text-14-600"
                :style="{ color: isMobileView ? '#000000' : '#B5B2B2' }"
              >
                {{ item.date }} {{ !isMobileView ? item.due : "" }}
              </div>
            </v-col>
            <v-col cols="6" md="4" class="pt-0">
              <div class="d-flex align-center">
                <v-avatar color="#0C5DF3" :size="isMobileView ? 22 : 28" class="mr-2">
                  <span :class="{ 'text-14-600': !isMobileView, 'text-12': isMobileView }">
                    {{ getInitials(item.clint) }}
                  </span>
                </v-avatar>
                <div :class="{ 'text-14-600': !isMobileView, 'text-12-400': isMobileView }">
                  {{ item.clint }}
                </div>
              </div>
            </v-col>

            <v-col cols="4" md="4" v-if="isMobileView">
              <div class="d-flex align-center justify-end" style="column-gap: 30px">
                <v-btn color="#FDD9DB" icon fab size="x-small">
                  <v-icon color="#2E3A59" size="medium"> mdi-bell-off </v-icon>
                </v-btn>
                <v-btn color="#FDD9DB" icon fab size="x-small">
                  <v-icon color="#2E3A59" size="medium">
                    mdi mdi-message-processing-outline
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { nextTick } from "vue";
export default {
  data() {
    return {
      search: "",
      isMobileView: false,
      activeLink: "all-items",
      statuses: [
        {
          label: "Open Tasks",
          count: 24,
          iconColor: "#0BC2B3",
          color: "#0BC2B326",
          icon: "mdi mdi-tag-outline",
        },
        {
          label: "In Progress",
          count: 12,
          iconColor: "#6120E2",
          color: "#6120E226",
          icon: "mdi mdi-flag-outline",
        },
        {
          label: "QA Pending",
          count: 12,
          iconColor: "#DD0E1A",
          color: "#DD0E1A26",
          icon: "mdi mdi-clock-time-three-outline",
        },
        {
          label: "Clarification",
          count: 12,
          iconColor: "#1B56EA",
          color: "#1B56EA26",
          icon: "mdi-help-circle",
        },
        {
          label: "Received Today",
          count: 12,
          iconColor: "#FA6902",
          color: "#FA690226",
          icon: "mdi mdi-arrow-bottom-left",
        },
        {
          label: "Completed Today",
          count: 12,
          iconColor: "#07AF07",
          color: "#07AF0726",
          icon: "mdi mdi-arrow-top-right",
        },
      ],
      tasks: [
        {
          title: "FW: Batch #400129 - Ship Start Date: 12/20/24 - Cancel Date: 14/20/24",
          description: "Can you please send carton labels through PDF ?",
          icon: "mdi-file-pdf",
          date: "12-12-2024 7:50 PM",
          due: "10 days ago",
          code: "#SYN-1005",
          text: "Accessory Head Quarters",
          username: "Franklin Bennedict",
          clint: "Velayutham Sankaran",
          status: "Required",
        },
        {
          title: "FW: Batch #400129 - Ship Start Date: 12/20/24 - Cancel Date: 14/20/24",
          description: "Can you please extend the ship window ?",
          icon: "mdi-clock",
          date: "12-12-2024 7:50 PM",
          due: "10 days ago",
          userInitial: "S",
          code: "#SYN-1005",
          text: "Accessory Head Quarters",
          username: "Franklin Bennedict",
          clint: "Velayutham Sankaran",
          status: "Snoozed",
        },
        {
          title: "FW: Batch #400129 - Ship Start Date: 12/20/24 - Cancel Date: 14/20/24",
          description: "Can you please extend the ship window ?",
          icon: "mdi-clock-outline",
          date: "12-12-2024 7:50 PM",
          userInitial: "A",
          due: "10 days ago",
          code: "#SYN-1005",
          text: "Accessory Head Quarters",
          username: "Franklin Bennedict",
          clint: "Velayutham Sankaran",
          status: "Attention",
        },
        {
          title: "FW: Batch #400129 - Ship Start Date: 12/20/24 - Cancel Date: 14/20/24",
          description: "Can you please extend the ship window ?",
          icon: "mdi-check-circle-outline",
          date: "12-12-2024 7:50 PM",
          due: "10 days ago",
          userInitial: "J",
          code: "#SYN-1005",
          text: "Accessory Head Quarters",
          username: "Franklin Bennedict",
          clint: "Velayutham Sankaran",
          status: "Accepted",
        },
      ],
    };
  },
  computed: {
    filteredTasks() {
      return this.tasks.filter((task) =>
        task.title.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    getInitials(name) {
      if (!name) return "";
      let initials = "";
      for (let i = 0; i < name.length; i++) {
        if (i == 0 || name[i] == " ") {
          initials += name.charAt(name[i] == " " ? i + 1 : i);
        }
      }
      return initials;
    },
    getColor(status) {
      switch (status) {
        case "Required":
          return "#34A911";
        case "Snoozed":
          return "#A95011";
        case "Attention":
          return "#1134A9";
        case "Accepted":
          return "#8B11A9";
        default:
      }
    },
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 600;
    },
    setActive(link) {
      this.activeLink = link;
    },
    renderCharts() {
      const taskTrendChart = document.getElementById("taskTrend").getContext("2d");
      const distributionChart = document.getElementById("distribution").getContext("2d");

      new Chart(taskTrendChart, {
        type: "line",
        data: {
          labels: ["Day 1", "Day 2", "Day 3", "Day 4"],
          datasets: [
            {
              label: "Task Inflow",
              data: [12, 19, 3, 9],
              borderColor: "rgba(75, 192, 192, 1)",
              backgroundColor: "rgba(75, 192, 192, 0.2)",
            },
          ],
        },
      });

      new Chart(distributionChart, {
        type: "pie",
        data: {
          labels: ["Open", "In Progress", "Pending", "Completed"],
          datasets: [
            {
              label: "Task Distribution",
              data: [12, 15, 5, 10],
              backgroundColor: ["#4caf50", "#2196f3", "#ff9800", "#8B11A9"],
            },
          ],
        },
      });
    },
    actionpage() {
      this.$router.push("/action");
    },
  },
  created() {
    this.checkMobileView();
    window.addEventListener("resize", this.checkMobileView);
  },
  mounted() {
    nextTick(() => {
    this.renderCharts();
  });
    
  },
};
</script>

<style scoped>
.home-page {
  font-family: Quicksand !important;
}
.top-card {
  border-radius: 8px;
}
.text-14 {
  font-size: 14px;
}
.text-14-600 {
  font-size: 14px;
  font-weight: 600;
}
.text-16-400 {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}
.text-700 {
  font-family: Quicksand;
  font-size: 16px;
  font-weight: 700;
}
.text-20 {
  font-size: 20px;
  font-weight: 700;
}
.text-12 {
  font-size: 12px;
  font-weight: 300;
}
.text-14-500 {
  font-size: 14px;
  font-weight: 500;
}
.text-14-400 {
  font-size: 14px;
  font-weight: 400;
}
.tag {
  padding: 5px;
  font-size: 12px;
  color: #ffffff;
  border-radius: 4px;
}
.text-12-400 {
  font-size: 12px;
  font-weight: 400;
}
.text-16-500 {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
a {
  /* font-family: Inter; */
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  text-decoration: none;
}
a.active {
  color: #dd0e1a;
}
>>> .v-field__field {
  height: 35px !important;
}
>>> .v-field--variant-outlined,
.v-field--single-line,
.v-field--no-label {
  --v-field-padding-top: -20px !important;
}
>>> .v-input__control {
  background: #ebeaea;
}
</style>
